var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c("v-icon", { attrs: { color: "green darken-2" } }, [
        _vm._v("fas fa-check")
      ])
    : _c("v-icon", { attrs: { color: "red darken-2" } }, [
        _vm._v("fas fa-times")
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }